import { Content, Component, Element } from './DataStructures';
const e = {
  Audio: new Component({
    tagName: "AudioPlayer",
    props: {
      src: "",
      trackSource: "",
      completed: undefined
    }
  }),
  Callout: new Component({
    tagName: "TaskCallout",
    props: {
      picture: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/1200px-Cat03.jpg",
      details: new Content("An accessible description of the figure."),
      detailsName: "calloutdesc",
      alt: "Alt text for the callout.",
      hotspots: [{
        content: new Content("meow!"),
        label: "cat",
        placement: "right",
        style: {
          top: "0px",
          left: "0px",
          width: "150px",
          height: "150px"
        },
        shape: "Square"
      }]
    }
  }),
  Carousel: new Component({
    tagName: "TaskCarousel",
    props: {
      items: [new Content("Slide 1"), new Content("Slide 2"), new Content("Slide 3")]
    }
  }),
  "Chord Builder": new Component({
    tagName: "TaskChordBuilder",
    props: {
      musicConfiguration: "X:1;L:1/1;M:4/4;K:Cmaj treble",
      musicInitial: "[]",
      musicButtonNote: true,
      musicButtonFlat: true,
      musicButtonSharp: true,
      musicButtonNatural: false,
      musicButtonDoubleFlat: false,
      musicButtonDoubleSharp: false,
      musicDuration: "1000",
      correct: "[CEG]",
      feedbackCorrect: new Content("Correct!"),
      feedbackIncorrect: new Content("Incorrect. The answer is C E G."),
      answers: [{
        answer: "[CEG]",
        correct: true,
        feedback: "Very true"
      }, {
        answer: "[C'E'G']",
        correct: true,
        feedback: "This is also very true"
      }]
    }
  }),
  "Free Response": new Component({
    tagName: 'TaskFreeResponse',
    props: {
      label: "How was your day?",
      description: "Please enter a few words.",
      validators: [{
        test: new Function("value", "validity", `value.split(" ").length >= 3`),
        message: "Please enter at least 3 words to continue.",
        validationType: "At least 3 Words"
      }],
      feedbackInsufficient: "Your answer is insufficient."
    }
  }),
  "Image Click": new Component({
    tagName: "TaskImageClick",
    props: {
      picture: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/1200px-Cat03.jpg",
      alt: "A literal description of the image.",
      details: new Content("A figurative description of the image."),
      photoCredit: new Content(""),
      hotspots: [{
        correct: true,
        label: new Content("left ear"),
        feedback: new Content("Correct! Left ear."),
        style: {
          top: "0px",
          left: "0px",
          width: "50px",
          height: "50px"
        },
        shape: "Square"
      }]
    }
  }),
  "Image Figure": new Component({
    tagName: 'Figure',
    props: {
      src: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/1200px-Cat03.jpg",
      caption: new Content("A figurative description of the image."),
      alt: "A literal description of the image.",
      longAlt: new Content(""),
      photoCredit: new Content(""),
      style: {
        height: "525px"
      }
    }
  }),
  "Simple Image": new Component({
    tagName: "Image",
    props: {
      src: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Dog_Breeds.jpg/800px-Dog_Breeds.jpg",
      alt: "A literal description of the image.",
      longAlt: new Content("")
    }
  }),
  "Image Figure List": new Component({
    tagName: 'FigureList',
    props: {
      caption: new Content("A figurative description of the image."),
      photoCredit: new Content(""),
      imgHeight: '200px',
      placeContent: 'center',
      flexDirection: 'row'
    },
    children: [new Component({
      tagName: 'FigureList.Item',
      props: {
        src: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/1200px-Cat03.jpg",
        alt: "A literal description of the image.",
        longAlt: new Content("")
      }
    }), new Component({
      tagName: 'FigureList.Item',
      props: {
        src: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/1200px-Cat03.jpg",
        alt: "A literal description of the image.",
        longAlt: new Content("")
      }
    })]
  }),
  "Likert Scale": new Component({
    tagName: "TaskLikertScale",
    props: {
      intervals: 5,
      prompt: "How do you feel about _?",
      labels: [new Content("Opposed"), new Content("Concerned"), new Content("Unsure"), new Content("Optimistic"), new Content("Enthusiastic")]
    }
  }),
  "Multi-Choice": new Component({
    tagName: "TaskMultiChoice",
    props: {
      prompt: new Content("Question text goes here?"),
      choices: [new Content("Option 1"), new Content("Option 2"), new Content("Option 3")],
      correct: [0],
      feedback: [new Content("Option 1 feedback"), new Content("Option 2 feedback"), new Content("Option 3 feedback")],
      randomize: false,
      maxAttempts: -1,
      cols: 1,
      justifyChoices: "left"
    }
  }),
  "Multi-Select": new Component({
    tagName: "TaskMultiSelect",
    props: {
      prompt: new Content("Question text goes here?"),
      data: [{
        label: "Label 1",
        correct: true
      }, {
        label: "Label 2",
        correct: true
      }, {
        label: "Incorrect label",
        correct: false
      }],
      correctFeedback: new Content("Correct."),
      incorrectFeedback: new Content("Incorrect.")
    }
  }),
  // "Multi-Select Submit": new Component({
  //   tagName: "TaskMultiSelectSubmit",
  //   props: {
  //     prompt: new Content("Select the correct answer(s):"),
  //     data: [{
  //       value: new Content("correct answer"),
  //       correct: true,
  //     }, {
  //       value: new Content("correct"),
  //       correct: true,
  //     }, {
  //       value: new Content("incorrect"),
  //       correct: false,
  //     }],
  //     buttonWidth: "85px",
  //     correctFeedback: new Content("Correct."),
  //     incorrectFeedback: new Content("Incorrect."),
  //   }
  // }),
  "Music Player": new Component({
    tagName: "TaskMusicPlayer",
    props: {
      notation: `X:1 
L:1/1 
M: 
K:Cmin bass 
_E,F,G,_A,_B,`
    }
  }),
  "Music Viewer": new Component({
    tagName: "TaskMusicViewer",
    props: {
      rawAbc: `%%scale 2.0
%%stretchlast 1
%%notespacingfactor 1.2
X: 1
M: 4/4
L: 1/4
K: D
D F A D' D E' A'`,
      scoreCredit: "Shutterstock",
      staffWidth: "50%",
      longAlt: `This is an example of a longer alt text for a score, this could include more information
        about the notes on the staff, or be used in case there is a long stanza, and short alt is not enough`,
      alt: "A description of the sheet music."
    }
  }),
  Paragraph: new Element({
    tagName: 'p',
    children: new Content("Lorem ipsum dolor sit amet")
  }),
  "Passage Click": new Component({
    tagName: "TaskPassageClick",
    props: {
      prompt: new Content("Lorem ipsum dolor sit amet"),
      multiFeedbackCorrect: new Content("")
    },
    children: new Content(new Element({
      tagName: 'p',
      children: new Content("This ", new Component({
        tagName: "TaskPassageClick.Click",
        props: {
          feedback: new Content("Feedback text here"),
          correct: true
        },
        children: new Content("text")
      }), " is highlighted.  This ", new Component({
        tagName: "TaskPassageClick.Click",
        props: {
          feedback: new Content("Feedback text here"),
          correct: false
        },
        children: new Content("other text")
      }), " is also highlighted.")
    }))
  }),
  "Passage Reveal": new Component({
    tagName: "TaskPassageReveal",
    props: {
      noReveal: false
    },
    children: new Content("This ", new Component({
      tagName: "TaskPassageReveal.Passage",
      props: {
        color: "#dabeef"
      },
      children: new Content("text")
    }), " is highlighted.")
  }),
  "Passage Hover": new Component({
    tagName: "TaskPassageReveal",
    props: {
      noReveal: true
    },
    children: new Content("This ", new Component({
      tagName: "TaskPassageReveal.Passage",
      props: {
        color: "#dabeef",
        placement: "bottom",
        contents: new Content("This content appears in a tooltip.")
      },
      children: new Content("text")
    }), " is highlighted.")
  }),
  "Scale Builder": new Component({
    tagName: "TaskScaleBuilder",
    props: {
      musicConfiguration: "X:1;L:1/1;M:;K:C treble",
      musicInitial: "zzzzzzzz",
      answers: [{
        answer: "FGA_BC'D'E'F'",
        correct: true,
        feedback: "Very true"
      }, {
        answer: "FGA_BC'D'E'G'",
        correct: false,
        feedback: "This is incorrect"
      }],
      musicButtonNote: true,
      musicButtonFlat: true,
      musicButtonSharp: true,
      musicButtonNatural: false,
      musicButtonDoubleFlat: false,
      musicButtonDoubleSharp: false,
      musicDuration: 1000,
      feedbackCorrect: "Correct!",
      feedbackIncorrect: "Incorrect.",
      rangeLower: -10,
      rangeHigher: 20
    }
  }),
  "Select (Dropdown)": new Component({
    tagName: "TaskDropdownMulti",
    children: new Content("This is a prefix string", new Component({
      tagName: "TaskSelect",
      props: {
        srOnly: true,
        options: [new Content("Apples"), new Content("Oranges"), new Content("Pears")],
        feedback: [new Content("Incorrect. An apple contains 8.4 mg of vitamin C."), new Content("Correct. An orange contains 51.1 mg of vitamin C."), new Content("Incorrect. A pear contains 7 mg of vitamin C.")],
        buttonWidth: "100px",
        matchWidth: "button",
        correct: 1,
        inline: true,
        label: new Content("Select the fruit that is orange")
      }
    }), "This is a placeholder string", new Component({
      tagName: "TaskSelect",
      props: {
        srOnly: true,
        options: [new Content("Apples"), new Content("Oranges"), new Content("Pears")],
        feedback: [new Content("Incorrect. An apple contains 8.4 mg of vitamin C."), new Content("Correct. An orange contains 51.1 mg of vitamin C."), new Content("Incorrect. A pear contains 7 mg of vitamin C.")],
        buttonWidth: "100px",
        matchWidth: "button",
        correct: 1,
        inline: true,
        label: new Content("Select the fruit that is orange")
      }
    }), "This is a postfix string")
  }),
  "Sorting": new Component({
    tagName: "TaskSorting",
    props: {
      feedbackCorrect: new Content("You got it right."),
      feedbackIncorrect: new Content("You got it wrong."),
      prompt: new Content("Sort these options into their containers."),
      categories: [new Content("Category 1"), new Content("Category 2")],
      randomize: false
    },
    children: [new Component({
      tagName: "TaskSorting.Option",
      props: {
        category: 0
      },
      children: new Content("Lorem ipsum category 1")
    }), new Component({
      tagName: "TaskSorting.Option",
      props: {
        category: 1
      },
      children: new Content("Lorem ipsum category 2")
    })]
  }),
  "Tab Panel": new Component({
    tagName: "TaskTabPanel",
    props: {
      label: "tabs",
      contents: [{
        title: new Content("Tab 1"),
        contents: new Content("Tab 1")
      }, {
        title: new Content("Tab 2"),
        contents: new Content("Tab 2")
      }]
    }
  }),
  Tree: new Component({
    tagName: "TaskTree",
    children: new Content("You come across two doors. Which door do you choose?"),
    props: {
      paths: [{
        buttonProps: {
          children: new Content("Door 1")
        },
        content: new Content(new Component({
          tagName: "TaskTree",
          children: new Content("You win a new car! Double or nothing?"),
          props: {
            paths: [{
              buttonProps: {
                children: new Content("Double")
              },
              content: new Content(new Component({
                tagName: "TaskTree",
                children: new Content("You win two new cars!"),
                props: {
                  paths: []
                }
              }))
            }, {
              buttonProps: {
                children: new Content("Nothing")
              },
              content: new Content(new Component({
                tagName: "TaskTree",
                children: new Content("You win nothing."),
                props: {
                  paths: []
                }
              }))
            }]
          }
        }))
      }, {
        buttonProps: {
          children: new Content("Door 2")
        },
        content: new Content(new Component({
          tagName: "TaskTree",
          children: new Content("You win nothing."),
          props: {
            paths: []
          }
        }))
      }]
    }
  }),
  "True-False": new Component({
    tagName: "TaskTrueFalse",
    props: {
      question: new Content("The sky is blue."),
      correct: true,
      correctFeedback: new Content("The blue color comes from the reflection of the sea. (????)"),
      incorrectFeedback: new Content("Incorrect.")
    }
  }),
  "Columns": new Component({
    tagName: 'Row',
    children: new Content(new Component({
      tagName: 'Col',
      props: {
        md: 6
      },
      children: new Content(new Element({
        tagName: 'p',
        children: new Content("Lorem ipsum dolor sit amet")
      }))
    }), new Component({
      tagName: 'Col',
      props: {
        md: 6
      },
      children: new Content(new Element({
        tagName: 'p',
        children: new Content("Amet sit dolor ipsum lorem")
      }))
    }))
  }),
  "Voice Builder": new Component({
    tagName: "TaskVoiceBuilder",
    props: {
      musicConfiguration: "%%annotationfont Times-Roman 14;X:1;L:1/4;M:;K:D;%%staves {(S A) (T B N)} ",
      musicAnnotation: `"@-65,-60 D:" "@-7,-60 III\\201"x "@-4,-60 ii" "@6,-60 ⁶"x "@-11,-60 V" "@-4,-60 \\202" "@10,-60 ⁷" "@10,-60 ₅"x "@4,-60 I"x`,
      musicInitial: "x x x x ; C B, _E D; F, E, G, F, ; F,, G,, A,, D,",
      answers: [{
        answer: "^A B C' D' ; C B, _E D; F, E, G, F, ; F,, G,, A,, D,",
        correct: true,
        feedback: "Very true"
      }],
      musicDuration: "3500",
      musicButtonFlat: true,
      musicButtonSharp: true,
      musicButtonNatural: true,
      musicButtonDoubleSharp: false,
      musicButtonDoubleFlat: false,
      musicButtonSATB: true,
      musicButtonSoprano: true,
      musicButtonAlto: false,
      musicButtonTenor: false,
      musicButtonBass: false,
      feedbackCorrect: new Content(`In an augmented triad, the interval between the root and third is a major third and the interval between the root and fifth is an augmented fifth. So, F–A–C spells an augmented triad on an F root.`),
      feedbackIncorrect: new Content(`Listen to the triad again. It contains a major third between the root and third. What is the quality of the interval between the root and fifth?`)
    }
  }),
  "Video Player": new Component({
    tagName: "VideoPlayer",
    props: {
      src: "",
      style: {
        margin: "auto"
      }
    }
  }),
  "Graph Slider": new Component({
    tagName: "TaskGraphSliderConfigurable",
    props: {
      spaceBetweenPoints: 1,
      equations: [[{
        label: 'eq1',
        yEquals: 'a * x + b',
        borderColor: '#595959',
        borderDash: [10, 5]
      }, {
        label: 'eq1',
        yEquals: 'a * x + b',
        borderColor: '#595959',
        borderDash: [10, 5]
      }]],
      pointSets: [[[{
        xEquals: '0',
        yEquals: 'b'
      }, {
        xEquals: '-b / a',
        yEquals: '0'
      }]]],
      graphs: [{
        canvasAltText: "Graph of slope-intercept form",
        options: {
          responsive: true,
          maintainAspectRatio: false,
          animation: false,
          scales: {
            x: {
              min: -15,
              max: 15,
              title: {
                text: "x"
              },
              tickInterval: 5
            },
            y: {
              min: 0,
              max: 30,
              title: {
                text: "y"
              },
              tickInterval: 5
            }
          }
        }
      }],
      trackRanges: [[{
        min: {
          label: new Content("-4"),
          value: -4
        },
        max: {
          label: new Content("4"),
          value: 4
        },
        minAnchor: 0,
        maxAnchor: 100
      }], [{
        min: {
          label: new Content("0"),
          value: 0
        },
        max: {
          label: new Content("15"),
          value: 15
        },
        minAnchor: 0,
        maxAnchor: 100
      }]],
      sliders: [{
        initialPosition: 50,
        label: new Content("Slope (m)"),
        ariaLabelForHandle: "Choose a value for variable m."
      }, {
        initialPosition: 50,
        label: new Content("Intercept (b)"),
        ariaLabelForHandle: "Choose a value for variable b."
      }],
      texts: [{
        sliderRanges: [[-4, -0.01], [0, 15]],
        sliderPositions: [[0, 50], [0, 100]],
        text: new Content("At slopes less than zero, the x-intercept is positive."),
        altText: "As the slope gets more negative, the line's x-intercept gets more positive."
      }, {
        sliderRanges: [[0, 0], [0, 15]],
        sliderPositions: [[50, 50], [0, 100]],
        text: new Content("At slopes equal to zero, the x-intercept is undefined."),
        altText: "At slopes equal to zero, the x-intercept is undefined."
      }, {
        sliderRanges: [[0.01, 4], [0, 15]],
        sliderPositions: [[50, 100], [0, 100]],
        text: new Content("At slopes greater than zero, the x-intercept is negative."),
        altText: "As the slope gets more positive, the line's x-intercept gets more negative."
      }]
    }
  })
};
export default e;